export function getRequestSendingEndpoint(): string {
    return `/request/send`;
}
